import { httpsCallable } from 'firebase/functions';

import { functions } from '../firebase';

const getCallableErrorMessage = (error, fallback) => {
  const backendMessage =
    typeof error?.message === 'string'
      ? error.message.replace(/^FirebaseError:\s*/i, '').trim()
      : '';

  if (backendMessage) {
    return backendMessage;
  }

  if (error?.code === 'functions/unauthenticated') {
    return 'You must be signed in to perform this action.';
  }

  if (error?.code === 'functions/permission-denied') {
    return 'Only owner accounts can restore backups.';
  }

  return fallback;
};

export const restoreBackup = async (backup) => {
  try {
    const restoreBackupCallable = httpsCallable(functions, 'restoreBackup');
    const result = await restoreBackupCallable({
      backup,
      confirmed: true,
    });

    return result.data;
  } catch (error) {
    throw new Error(getCallableErrorMessage(error, 'Failed to restore backup.'));
  }
};

export const logSystemAuditEvent = async (eventType, metadata = {}) => {
  try {
    const logSystemEvent = httpsCallable(functions, 'logSystemAuditEvent');
    const result = await logSystemEvent({
      eventType,
      metadata,
    });

    return result.data;
  } catch (error) {
    throw new Error(getCallableErrorMessage(error, 'Failed to log system action.'));
  }
};
